import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 shadow-md border-b border-red-700" data-id="element-181">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-182">
        <span className="text-white font-bold text-sm sm:text-base uppercase tracking-wide" data-id="element-183">
          Esta oferta termina pronto
        </span>
        <CountdownTimer variant="bar" data-id="element-184" />
      </div>
    </div>;
}